import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {GoogleAnalyticsService} from "~/app/core/services/google-analytics.service";
import {ErrorApiService} from "~/app/test/error-api.service";
import {LocalStorageIndexedService} from "~/app/web/AppProvider/LocalStorageIndexedService";
import {UserService} from "~/app/core/services/user.service";
import {JwtService} from "mclane-webauth-lib";


@Injectable({
  providedIn: 'root'
})
export class BaseService {
  constructor(public httpClient: HttpClient,
              public googleAnalyticsService: GoogleAnalyticsService,
              public localStorage: LocalStorageIndexedService,
              private jwt: JwtService) {
  }

  test: any;

  public getHttp(eventAction: string, eventCategory: string, eventLabel: string) {
    this.eventEmitter(
      eventAction,
      eventCategory,
      eventLabel);
    return this.httpClient.get(eventLabel);
  }

  public getHttpOptions(eventAction: string, eventCategory: string, eventLabel: string, options?: any) {
    this.eventEmitter(
      eventAction,
      eventCategory,
      eventLabel);
    return this.httpClient.get(eventLabel, options);
  }

  public getHttpOptionsForReportService(eventAction: string, eventCategory: string, eventLabel: string) {
    this.eventEmitter(
      eventAction,
      eventCategory,
      eventLabel);
    const httpOptions = {
      headers: new HttpHeaders({'Content-Type': 'application/json'})
    };
    return this.httpClient.get(eventLabel, httpOptions);
  }


  getHttpBlob(eventAction: string, eventCategory: string, eventLabel: string) {
    this.eventEmitter(
      eventAction,
      eventCategory,
      eventLabel);
    return this.httpClient.get(eventLabel, {responseType: 'blob'});
  }

  public getHttpObject<t>(eventAction: string, eventCategory: string, eventLabel: string) {
    this.eventEmitter(
      eventAction,
      eventCategory,
      eventLabel);
    return this.httpClient.get<t>(eventLabel);
  }

  public getHttpObjectOptions<t>(eventAction: string, eventCategory: string, eventLabel: string, options?: any) {
    this.eventEmitter(
      eventAction,
      eventCategory,
      eventLabel);
    const httpOptions = {
      headers: new HttpHeaders({'Content-Type': 'application/json'})
    };
    return this.httpClient.get<t>(eventLabel, httpOptions);
  }

  public putHttp(eventAction: string, eventCategory: string, eventLabel: string) {
    this.eventEmitter(
      eventAction,
      eventCategory,
      eventLabel);
    return this.httpClient.put(eventLabel, {});
  }

  public putHttpObject<t>(eventAction: string, eventCategory: string, eventLabel: string, object: any, options?: any) {
    this.eventEmitter(
      eventAction,
      eventCategory,
      eventLabel);
    return this.httpClient.put<t>(eventLabel, object, options);
  }

  public putHttpObjectOptions<t>(eventAction: string, eventCategory: string, eventLabel: string, object: any, options?: any) {
    this.eventEmitter(
      eventAction,
      eventCategory,
      eventLabel);
    const httpOptions = {
      headers: new HttpHeaders({'Content-Type': 'application/json'})
    };
    return this.httpClient.put<t>(eventLabel, object, {
      headers: httpOptions.headers,
      observe: 'response'
    });
  }

  public putHttpJsonOptions(eventAction: string, eventCategory: string, eventLabel: string, json: any, options?: any) {
    this.eventEmitter(
      eventAction,
      eventCategory,
      eventLabel);
    return this.httpClient.put(eventLabel, json, options);
  }

  public postHttp(eventAction: string, eventCategory: string, eventLabel: string) {
    this.eventEmitter(
      eventAction,
      eventCategory,
      eventLabel);
    return this.httpClient.post(eventLabel, {observe: 'response'});
  }

  public postHttpObject<t>(eventAction: string, eventCategory: string, eventLabel: string, object: any, options?: any) {
    this.eventEmitter(
      eventAction,
      eventCategory,
      eventLabel);
    return this.httpClient.post<t>(eventLabel, object, options);
  }

  public postHttpObjectArray(eventAction: string, eventCategory: string, eventLabel: string, object: any, options?: any) {
    this.eventEmitter(
      eventAction,
      eventCategory,
      eventLabel);
    return this.httpClient.post(eventLabel, object, options);
  }

  public postHttpObjectArrayNoOptions(eventAction: string, eventCategory: string, eventLabel: string, object: any, options?: any) {
    this.eventEmitter(
      eventAction,
      eventCategory,
      eventLabel);
    return this.httpClient.post(eventLabel, object);
  }

  public postHttpObjectResponse(eventAction: string, eventCategory: string, eventLabel: string, object: any, options?: any) {
    this.eventEmitter(
      eventAction,
      eventCategory,
      eventLabel);
    const httpOptions = {
      headers: new HttpHeaders({'Content-Type': 'application/json'})
    };
    return this.httpClient.post(eventLabel, object, {headers: httpOptions.headers, observe: 'response'});
  }


  public postHttpJson(eventAction: string, eventCategory: string, eventLabel: string, json: string, options?: any) {
    this.eventEmitter(
      eventAction,
      eventCategory,
      eventLabel + ' {JSON: ' + json + '}');
    return this.httpClient.post(eventLabel, json);
  }

  public postHttpJsonOptions(eventAction: string, eventCategory: string, eventLabel: string, json: string, options?: any) {
    this.eventEmitter(
      eventAction,
      eventCategory,
      eventLabel + ' {JSON: ' + json + '}');
    return this.httpClient.post(eventLabel, json, options);
  }


  public postHttpJsonObject<t>(eventAction: string, eventCategory: string, eventLabel: string, json: string, options?: any) {
    this.eventEmitter(
      eventAction,
      eventCategory,
      eventLabel + ' {JSON: ' + json + '}');
    return this.httpClient.post<t>(eventLabel, json);
  }


  public postHttpResponseText(eventAction: string, eventCategory: string, eventLabel: string, json: string) {
    this.eventEmitter(
      eventAction,
      eventCategory,
      eventLabel + ' {JSON: ' + json + '}');
    return this.httpClient.post(eventLabel, json, {responseType: 'text'});
  }


  public postHttpResponse(eventAction: string, eventCategory: string, eventLabel: string, json: string) {
    this.eventEmitter(
      eventAction,
      eventCategory,
      eventLabel + ' {JSON: ' + json + '}');
    return this.httpClient.post(eventLabel, json, {observe: 'response'});
  }

  public postHttpResponsePlain(eventAction: string, eventCategory: string, eventLabel: string, json: string) {
    this.eventEmitter(
      eventAction,
      eventCategory,
      eventLabel + ' {JSON: ' + json + '}');
    return this.httpClient.post(eventLabel, json);
  }



  public postHttpJsonBlob(eventAction: string, eventCategory: string, eventLabel: string, json: string) {
    this.eventEmitter(
      eventAction,
      eventCategory,
      eventLabel + ' {JSON: ' + json + '}');
    return this.httpClient.post(eventLabel, json, {responseType: 'blob'});
  }

  public postHttpJsonBlobOptions(eventAction: string, eventCategory: string, eventLabel: string, json: string, options?: any) {
    this.eventEmitter(
      eventAction,
      eventCategory,
      eventLabel + ' {JSON: ' + json + '}');
    return this.httpClient.post(eventLabel, json, options);
  }

  public deleteHttp(eventAction: string, eventCategory: string, eventLabel: string) {
    this.eventEmitter(
      eventAction,
      eventCategory,
      eventLabel);
    return this.httpClient.delete(eventLabel, {observe: 'response'});
  }

  public deleteHttpOptions(eventAction: string, eventCategory: string, eventLabel: string, options?: any) {
    this.eventEmitter(
      eventAction,
      eventCategory,
      eventLabel);
    return this.httpClient.delete(eventLabel, options);
  }

  public deleteHttpResponse(eventAction: string, eventCategory: string, eventLabel: string) {
    this.eventEmitter(
      eventAction,
      eventCategory,
      eventLabel);
    const httpOptions = {
      headers: new HttpHeaders({'Content-Type': 'application/json'})
    };
    return this.httpClient.delete(eventLabel, {headers: httpOptions.headers, observe: 'response'});
  }

  public deleteHttpObject<T>(eventAction: string, eventCategory: string, eventLabel: string, object: any) {
    this.eventEmitter(
      eventAction,
      eventCategory,
      eventLabel);
    // return this.httpClient.delete(eventLabel, {observe: 'response'});
    return this.httpClient.delete<T>(eventLabel, object);
  }

  eventEmitter(eventAction, eventCategory, eventLabel) {
    console.log('eventEmitter:: ', this.localStorage.getFromSession('homeOffice'));
    console.log('userID:: ', this.jwt.preferred_username);
    console.log('eventAction - ', eventAction);
    console.log('eventCategory - ', eventCategory);
    console.log('eventLabel - ', eventLabel);
    this.googleAnalyticsService.eventEmitter(
      eventAction,
      eventCategory,
      this.jwt.preferred_username + ': ' + eventLabel,
      1);
  }


}
